import './index.css';
import * as React from 'react';
import { Dispatch, RootState } from '@/src/pages/homepage/quality_special_page_main/models/store';
import { connect } from '@wmfe/mach-pro-store';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapStateToProps = (state: RootState, dispatch: Dispatch) => ({});
const WMRouter = Mach.requireModule('Router');

type BaseIProps = ReturnType<typeof mapStateToProps>;

interface Props extends BaseIProps {
  apiData?: any;
}

interface State {}

/**
 * 心智头图组件
 * @param apiData
 */
class HeaderImage extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  componentDidMount(): void {}

  componentWillUnmount(): void {}

  handleOnRuleClick() {
    const linkUrl = this.props.apiData?.json_data?.ruleInfo?.linkUrl;
    if (linkUrl) {
      WMRouter.navigateTo(
        linkUrl,
        {},
      );
    }
  }

  render() {
    let defaultImage = 'assets://placeholder/icon_placeholder_16:9.png';
    const {
      picUrl, aspectRatio, ruleInfo, bottomBarColor
    } = this.props.apiData?.json_data || {};
    let ratio = 9 / 16; // 默认 16:9
    if (aspectRatio == '4:3') {
      ratio = 3 / 4;
    } else if (aspectRatio === '1:1') {
      defaultImage = 'assets://placeholder/icon_placeholder_1:1.png';
      ratio = 1;
    }
    const picHeight = Number(Mach.env?.screenWidth) * ratio;
    const {
      ruleText, ruleIcon, ruleTextColor
    } = ruleInfo || {};

    return (
      <view style={{ minHeight: picHeight, width: '100%' }}>
        <image
          style={{ height: picHeight, width: '100%' }}
          resizeMode="stretch"
          src={picUrl || defaultImage}
          placeholder={defaultImage}
          error={defaultImage}
        />

        {ruleInfo && (
          <view className="rule-info-container" onClick={this.handleOnRuleClick.bind(this)}>
            <view>
              <text className="rule-info-text" style={{ color: ruleTextColor }} content={ruleText} />
              {ruleIcon && <image className="rule-info-icon" src={ruleIcon} />}
            </view>
          </view>
        )}

        <view
          style={{
            // 颜色：：这里是那个写死的小边边
            backgroundColor: bottomBarColor || '#F7F7F7',
            width: '100%',
            height: '12',
            bottom: -0.5,
            position: 'absolute',
            borderTopLeftRadius: '12',
            borderTopRightRadius: '12',
          }}
        />
      </view>
    );
  }
}

export default connect(mapStateToProps)(HeaderImage);
